module.exports = __webpack_public_path__ + "img/3.ec266d38.jpg";